import axios from "axios";

const state = {
  permissions: [],
};

const actions = {
  getAll: (context, { params = {} } = {}) => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        url: context.rootGetters.baseUrl + "permissions",
        params,
      })
        .then((response) => {
          const permissions = response.data.data.data;
          context.commit("PERMISSIONS_UPDATE", permissions);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

const mutations = {
  PERMISSIONS_UPDATE: (state, permissions) => {
    state.permissions = permissions;
  },
};

const getters = {
  permissions: (state) => state.permissions,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
